import { Button, Label } from 'components/atoms';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import { PiTrash } from 'react-icons/pi';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { IChildrenProp } from 'types/components/components.interface';
import { removeItem } from 'utils/dnd/dndUtilities';
import ContractSideMenuWrapper from '../../wrapper/ContractSideMenuWrapper';

interface IContractDetailsPageProps extends IChildrenProp {}

const ContractDetailsPage = ({ children }: IContractDetailsPageProps) => {
  const { values, namePrefix, setFieldValue, detailId, hideContract } =
    useFormikContractHelpers();
  const { t } = useTranslation();

  const removeDisplayedItem = () => {
    setFieldValue(`${namePrefix}`, removeItem(values.items, detailId));
    setFieldValue('sideMenu.displayed', false);
  };

  return (
    <ContractSideMenuWrapper
      header={
        <>
          <Label withText>
            {t('contract-template.agreement.detail-header')}
          </Label>
          <Button
            onlyIcon
            isClear
            disabled={hideContract}
            onClick={removeDisplayedItem}
            variant={BUTTON_VARIANT.remove}>
            <Button.Description description={t('button.remove')} />
            <Button.Icon icon={<PiTrash />} />
          </Button>
        </>
      }>
      {children}
    </ContractSideMenuWrapper>
  );
};

export default ContractDetailsPage;
